import React from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { Checkbox, Dropdown, TextInput } from "colbi_web_ui/lib/components/inputs";
import defaultStyles from "./PackageDropdownQuantitySelector.module.sass";
import { SovosIcon } from "mosaic-react";
import { HighlightOff } from "mosaic-react-icons";

const PackageDropdownQuantitySelector = ({
    selectedPackages,
    packages,
    handleChange,
    entitieID,
    styles,
    containerTitle,
    entitieKey,
}) => {
    const selectedStyles = styles ? styles : defaultStyles;
    const { i18n } = useGlobalValue();
    const packagesList = packages || [];
    const valuesSelected = selectedPackages || [];
    const availablePackages = parseAvailablePackages(packagesList, valuesSelected);
    let itemsElements = buildItemsElements(valuesSelected, availablePackages);

    function parseAvailablePackages(packages, packagesSelected) {
        return packages.filter(
            (item) => !packagesSelected.some((obj) => obj.packageId === item.id),
        );
    }

    function buildItemsElements(packagesSelected, availablePackages) {
        return (packagesSelected || []).map((item, index) => {
            const packageSelected = packagesList
                ? packagesList.find((_package) => item.packageId === _package.id)
                : {};
            return (
                <div key={index} className={selectedStyles["item-entry"]}>
                    <div className={selectedStyles["remove-button-container"]}>
                        <button
                            type="button"
                            className={selectedStyles["remove-button"]}
                            onClick={(e) => {
                                const updatedItems = valuesSelected.filter(
                                    (item, idx) => idx !== index,
                                );
                                handleChange(e, "Packages", updatedItems);
                            }}
                        >
                            <SovosIcon>
                                <HighlightOff />
                            </SovosIcon>
                        </button>
                    </div>
                    <div className={selectedStyles["package-container"]}>
                        <div className={selectedStyles["select-package-container"]}>
                            <h5 className={selectedStyles["label"]}>{i18n`Package`}</h5>
                            <Dropdown
                                value={packageSelected}
                                options={availablePackages || []}
                                className={selectedStyles["dropdown"]}
                                placeholder={i18n`select package`}
                                required
                                filter
                                onChange={(e) => {
                                    packagesSelected[index] = {
                                        ...packagesSelected[index],
                                        packageId: e.target.value.id,
                                    };
                                    handleChange(e, "Packages", packagesSelected);
                                }}
                            />
                        </div>
                        <div className={selectedStyles["quantity-container"]}>
                            <TextInput
                                type="number"
                                min="0"
                                autoComplete="off"
                                autoCorrect="off"
                                spellCheck="false"
                                name={i18n`Quantity`}
                                placeholder={i18n`Enter a package quantity`}
                                value={item.quantity || ""}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    const quantity =
                                        inputValue === ""
                                            ? null
                                            : Math.abs(parseInt(inputValue)) || 1;
                                    packagesSelected[index] = {
                                        ...packagesSelected[index],
                                        quantity,
                                    };
                                    handleChange(e, "Packages", packagesSelected);
                                }}
                            />
                        </div>
                    </div>

                    <div className={selectedStyles["package-container"]}>
                        <div className={selectedStyles["inherited-container"]}>
                            <Checkbox
                                value={item.inherit}
                                onChange={(e) => {
                                    const inherit = e.target.checked ? 1 : 0;
                                    packagesSelected[index] = {
                                        ...packagesSelected[index],
                                        inherit,
                                    };
                                    handleChange(e, "Packages", packagesSelected);
                                }}
                            >{i18n`Allow Inheritance`}</Checkbox>
                        </div>
                    </div>
                </div>
            );
        });
    }

    return (
        <>
            {containerTitle && (
                <h5 className={selectedStyles["label"]}>{i18n`${containerTitle}`}</h5>
            )}
            <div className={selectedStyles["flex"]}>
                <div className={selectedStyles["item-container"]}>
                    <div>
                        {(itemsElements || []).length ? (
                            itemsElements
                        ) : (
                            <small>{i18n`No packages assigned`}</small>
                        )}
                    </div>
                    <div>
                        <button
                            className={selectedStyles["add-button"]}
                            type="button"
                            onClick={(e) => {
                                const newItem = {};
                                newItem[entitieKey] = +entitieID;

                                const itemsUpdated = [...valuesSelected, newItem];
                                handleChange(e, "Packages", itemsUpdated);
                            }}
                        >
                            {availablePackages && availablePackages.length ? (
                                <small>{i18n`[+] Add new Package`}</small>
                            ) : null}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PackageDropdownQuantitySelector;
